import { FC, useContext, useEffect, useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";

// import { RepriseReimbursementResourcesLogo } from "../../assets";
import { AuthContext } from "../../context/authContext";
import { AuthenticatedRoutes, ManufacturerRoutes } from "../../routes/AppRoutes";

const HubSplashScreen: FC = (): JSX.Element => {
  const { isManufacturer, isUserAuthorized, userData, isRestoreCalled, restoreSession } = useContext(AuthContext);
  const navigate = useNavigate();

  useLayoutEffect(() => {
    if (!localStorage.getItem("token")) {
      if (
        window.location.pathname === "/" ||
        [...ManufacturerRoutes, ...AuthenticatedRoutes].find((route) => route.route === window.location.pathname)
      ) {
        const redirect_url = process.env.REACT_APP_PUBLIC_REDIRECT_URL
        if (redirect_url) window.location.replace(redirect_url)
      }
    }
  }, [])

  const checkForAuthentication = () => {
    if (isUserAuthorized) {
      if (isManufacturer) {
        const indexRoute = ManufacturerRoutes.find((route) => route.isIndex);
        if (indexRoute) navigate(indexRoute.route);
      } else {
        const indexRoute = AuthenticatedRoutes.find((route) => route.isIndex);
        if (indexRoute) navigate(indexRoute.route);
      }
    }
  };

  useEffect(() => {
    if (isRestoreCalled) {
      checkForAuthentication();
    } else if (!userData) {
      restoreSession();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRestoreCalled]);

  return (
    <div className="container-fluid row justify-content-center align-items-center pt-4 pb-5" style={{ height: '100vh' }}>
      <div className="col-12 text-center">
        {/*<img height="110px" className="img-fluid mt-3" src={RepriseReimbursementResourcesLogo} alt="Site logo" />*/}

        <div className="mt-2">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HubSplashScreen;
